import { render, staticRenderFns } from "./Development.vue?vue&type=template&id=6318cffa&scoped=true&"
import script from "./Development.vue?vue&type=script&lang=js&"
export * from "./Development.vue?vue&type=script&lang=js&"
import style0 from "./Development.vue?vue&type=style&index=0&id=6318cffa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318cffa",
  null
  
)

export default component.exports